BoardListItemComponent = require './board-list-item-component'
f = require 'effing'
React = require 'react'
ReactDnd = require 'react-dnd'
ReactDOM = require '@trello/react-dom-wrapper'
recup = require 'recup'
xtend = require 'xtend'

_BoardListItemDndComponent = class extends React.Component
  displayName: 'BoardListItemDndComponent'
  render: ->
    { connectDropTarget, connectDragSource, isDragging } = @props
    if isDragging
      recup.render ->
        recup.li('.boards-page-board-section-list-item.mod-placeholder')
    else
      newProps = xtend @props, ref: (instance) ->
        connectDropTarget(ReactDOM.findDOMNode(instance))
        connectDragSource(ReactDOM.findDOMNode(instance))
      React.createElement(BoardListItemComponent, newProps)

dropSpec =
  canDrop: ->
    false
  hover: (props, monitor) ->
    if props.id != monitor.getItem().id
      props.onDragHover(monitor.getItem().id)

dropCollect = (connect, monitor) ->
  connectDropTarget: connect.dropTarget()

dragSpec =
  beginDrag: (props) ->
    id: props.id
  endDrag: (props) ->
    props.onDragEnd()

dragCollect = (connect, monitor) ->
  connectDragSource: connect.dragSource()
  isDragging: monitor.isDragging()

module.exports = ReactDnd.DragSource('BoardTile', dragSpec, dragCollect)(ReactDnd.DropTarget('BoardTile', dropSpec, dropCollect)(_BoardListItemDndComponent))
